import axios from "axios";
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { FaEllipsisH, FaPlusCircle, FaSearch } from "react-icons/fa";
import { Link } from "react-router-dom";
import styles from './EmployeeTable.module.css';
import { message } from "antd";
import APIURL, { IMAGE_BASE_URL } from "../api/apiClient";
import Loader from "./Loader";


const EmployeeTable = () => {
const [loading, setLoading] = useState(false);
    const [dataRecords, setDataRecords] = useState([]);
    const [filerData, setFilterData] = useState([]);
    const [visibleRow, setVisibleRow] = useState('');
    const [perPage, setPerPage] = useState(10)
    const [currentPage, setCurrentPage] = useState(1)

    const columns = [

        {
            name: 'S.No',
            cell: (row, index) => <div>{(currentPage - 1) * perPage + index + 1}</div>,
            width: '80px',
        },
        {
            // name: 'Profile',
            cell: row => {
                const profileUrl =  `${IMAGE_BASE_URL}${row.profile_image}`;
               return (
                                <div
                                    style={{
                                        width: "100px",
                                        height: "100px",
                                        overflow: "hidden",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                >
                                    <img
                                        src={
                                            profileUrl ||
                                            `${IMAGE_BASE_URL}/uploads/profileplaceholder.png`
                                        }
                                        onError={(e) => {
                                            e.target.onerror = null; // Prevents infinite loop
                                            e.target.src =
                                                `${IMAGE_BASE_URL}/uploads/images/profileplaceholder.png`
                                        }}
                                        alt="Item image"
                                        style={{
                                            maxWidth: "100%",
                                            maxHeight: "100%",
                                            objectFit: "cover",
                                            borderRadius: "8px",
                                        }}
                                    />
                                </div>
                            );
            
            }
        },

        {
            name: "Title",
            selector: row => row.title
        },

        {
            name: "Name",
            selector: row => row.first_name
        },

        {
            name: "DOB",
            selector: row => row.date_of_birth
        },

        {
            name: "Mobile",
            selector: row => row.mobile_no
        },

        {
            name: "Qualifications",
            selector: row => row.highest_qualification
        },

        {
            cell: (row) => (
                <div style={{ position: "relative", display: "inline-block" }}>
                    <button className={styles.more_button}
                        onClick={() => setVisibleRow(visibleRow === row.id ? null : row.id)} >
                        <FaEllipsisH id={styles.more} />
                    </button>
                    {visibleRow === row.id && (
                        <div className={styles.dropdown_menu}>
                            <p id={styles.actions}>Actions</p>
                            <Link to={`/editEmployee/${row.id}`}
                                className={styles.edit}>
                                Edit
                            </Link>

                            <button className={styles.delete}
                                onClick={(e) => handleDelete(row.id)}>
                                Delete
                            </button>

                        </div>

                    )}
                </div>
            )

        },
    ];


    useEffect(() => {
        const fetchRecords = async () => {
            setLoading(true);
            try {
                // Using your APIURL client
                const employees = await APIURL.get("/fetchemployee.php");

                // Ensure response is always an array
                const employeeArray = Array.isArray(employees) ? employees : [];

                // Save both main and filtered data
                setDataRecords(employeeArray);
                setFilterData(employeeArray);
            } catch (error) {
                console.error("Failed to fetch employee list:", error);
                setDataRecords([]);  // fallback empty on error
                setFilterData([]);   // fallback empty on error
            } finally{
                setLoading(false);
            }
        };
        fetchRecords();
    }, []);



    const handleFilter = (event) => {
        const newData = filerData.filter(row => row.first_name.toLowerCase().includes(event.target.value.toLowerCase()))
        setDataRecords(newData);
    }

    const handleDelete = async (id) => {
        const confirmDelete = window.confirm('Would you like to delete?');
        if (!confirmDelete) return;

        try {
            const response = await APIURL.delete(`/deleteemployee.php?id=${id}`);
            console.log(response); // Handle the success response

            // Update state to reflect the changes
            setDataRecords((prevDataRecords) => prevDataRecords.filter((employee) => employee.id !== id));
            setFilterData((prevFilterData) => prevFilterData.filter((employee) => employee.id !== id));

            message.success('Employee deleted successfully.');
        } catch (error) {
            console.error('Failed to delete employee:', error);
            message.error('Failed to delete employee. Please try again.');
        }
    };

    return (
        <div>
            <div className={styles.searchContainer}>
                <div className={styles.search}>
                    <FaSearch className={styles.iconSearch} />
                    <input placeholder="Search..." className={styles.inputSearch} onChange={handleFilter} />
                </div>

                <Link to="/employee" className={styles.addEmployee}>
                    <FaPlusCircle className={styles.iconAdd} />
                    Add Employee
                </Link>
            </div>

            <div className={styles.table_container}>
                <DataTable
                    title="Employee Master"
                    columns={columns}
                    data={dataRecords}
                    pagination
                    onChangePage={page => setCurrentPage(page)}
                    onChangeRowsPerPage={(newPerPage, page) => {
                        setPerPage(newPerPage);
                        setCurrentPage(page);
                    }}
                    paginationRowsPerPageOptions={[5, 10, 20]}
                    paginationComponentOptions={{
                        rowsPerPageText: 'Items per page:',
                        rangeSeparatorText: 'of',
                    }}
                    progressPending={loading}
                    progressComponent={<Loader type="table" loading={loading} />}
                    noDataComponent={loading ? null : "No records to display"}
                    customStyles={{
                        header: {
                            style: {
                                fontSize: '24px',
                            },
                        },
                        headCells: {
                            style: {
                                color: 'gray',
                                fontSize: '20px',
                                textAlign: 'center',
                            },
                        },
                        cells: {
                            style: {
                                fontSize: '17px',
                                textAlign: 'center',
                                padding: '20px',
                            },
                        },
                        rows: {
                            style: {
                                fontSize: '17px',
                                height: '100px',
                                '&:hover': {
                                    backgroundColor: '#f9f9f9',
                                },
                            },
                        },
                    }}

                />
            </div>
        </div>
    )

}

export default EmployeeTable